import React from 'react';
import { withRouter } from 'react-router-dom';
import ResumoAnualForm from './ResumoAnualForm.jsx';
import ResumoAnualVis from './ResumoAnualVis.jsx';

class ResumoAnual extends React.Component {

    constructor() {

        super();

        this.state = {
            disabled: false,
            centros:[],
            centro: "Centro",
            centroNome: "",
            anos: [],
            ano: "Ano",
            resumoAnual: [],
            conf: false
        };

        this.changeCentro = this.changeCentro.bind(this);
        this.changeAno = this.changeAno.bind(this);
        this.voltar = this.voltar.bind(this);
        this.visualizar = this.visualizar.bind(this);
        this.baixar = this.baixar.bind(this);
        this.voltar2 = this.voltar2.bind(this);

    }

    changeCentro(e) {

        let centro = e.target.value
        this.setState({ centro: centro });
        let index = e.target.selectedIndex;

        if (index !== 0) {
            this.setState({ centroNome: e.target[index].text });
        } else {
            this.setState({ centroNome: "" });
        }

        if (centro === "Centro") {

            this.setState({ anos: [] });
            this.setState({ ano: "Ano" });

        } else {

            fetch("/api/movimentacao/ano/" + centro, {
                method: "GET",
                headers: {
                    "Content-type": "application/json",
                    "Authorization": "Basic " + btoa(localStorage.auth)
                },
                mode: "cors"
            })
            .then(response => response.json())
            .then(responseJson => {

                this.setState({ anos: responseJson });

            });

        }

    }

    changeAno(e) {
        this.setState({ ano: e.target.value });
    }

    voltar() {
        this.props.history.push("/relatorios");
    }

    visualizar() {

        this.setState({ disabled: true });

        if (this.state.centro === "Centro") {

            this.props.errMsgHandler("Por favor, informe o centro de custo das movimentações financeiras.");
            this.setState({ disabled: false });

        } else if (this.state.ano === "Ano") {

            this.props.errMsgHandler("Por favor, informe o ano das movimentações financeiras.");
            this.setState({ disabled: false });

        } else {

            this.props.errMsgHandler("");
            this.props.waitMsgHandler("Aguardando");

            let centro = this.state.centro;
            let ano = this.state.ano;

            fetch("/api/movimentacao/resumo_anual/" + centro + "/" + ano, {
                method: "GET",
                headers: {
                    "Content-type": "application/json",
                    "Authorization": "Basic " + btoa(localStorage.auth)
                },
                mode: "cors"
            })
            .then(response => response.json())
            .then(responseJson => {

                this.setState({ resumoAnual: responseJson });
                this.setState({ conf: true });
                this.props.waitMsgHandler("");
                this.setState({ disabled: false });

            });

        }

    }

    baixar() {

        this.setState({ disabled: true });

        if (this.state.centro === "Centro") {

            this.props.errMsgHandler("Por favor, informe o centro de custo das movimentações financeiras.");
            this.setState({ disabled: false });

        } else if (this.state.ano === "Ano") {

            this.props.errMsgHandler("Por favor, informe o ano das movimentações financeiras.");
            this.setState({ disabled: false });

        } else {

            this.props.errMsgHandler("");
            this.props.waitMsgHandler("Aguardando");

            let centro = this.state.centro;
            let ano = this.state.ano;

            fetch("/api/movimentacao/resumo_anual/excel/" + centro + "/" + ano, {
                method: "GET",
                headers: {
                    "Content-type": "application/json",
                    "Authorization": "Basic " + btoa(localStorage.auth)
                },
                mode: "cors"
            })
            .then(response => response.json())
            .then(responseJson => {

                if (responseJson.msg !== "success") {

                    this.props.waitMsgHandler("");
                    this.props.errMsgHandler(responseJson.msg);
                    this.setState({ disabled: false });

                } else {

                    let obj = {
                        "file_name": responseJson.file
                    };

                    fetch("/api/movimentacao/resumo_anual/excel/baixar", {
                        method: "POST",
                        headers: {
                            "Content-type": "application/json",
                            "Authorization": "Basic " + btoa(localStorage.auth)
                        },
                        mode: "cors",
                        body: JSON.stringify(obj)
                    })
                    .then(response2 => response2.blob())
                    .then(blob => {

                        this.props.waitMsgHandler("");
                        this.setState({ disabled: false });

                        let url = window.URL.createObjectURL(blob);
                        let a = document.createElement("a");
                        a.href = url;
                        a.download = responseJson.file;
                        a.click();

                    });

                }

            });

        }

    }

    voltar2() {
        this.setState({ conf: false });
        this.setState({ resumoAnual: [] });
    }

    componentDidMount() {

        if (localStorage.roleRelatorios !== "escrever"
            && localStorage.roleRelatorios !== "ler") {

            window.location.href = "/home";

        }

        fetch("/api/centro/", {
            method: "GET",
            headers: {
                "Content-type": "application/json",
                "Authorization": "Basic " + btoa(localStorage.auth)
            },
            mode: "cors"
        })
        .then(response => response.json())
        .then(responseJson => {

            this.setState({ centros: responseJson });

        });

    }

    render() {
        return(
            <div>
                <h1 id="resumo-anual-title">Resumo Anual</h1><br />
                { this.state.conf === false &&
                    <ResumoAnualForm
                        centros={ this.state.centros }
                        centro={ this.state.centro }
                        anos={ this.state.anos }
                        ano={ this.state.ano }
                        changeCentro={ this.changeCentro }
                        changeAno={ this.changeAno }
                        voltar={ this.voltar }
                        visualizar={ this.visualizar }
                        baixar={ this.baixar }
                        disabled={ this.state.disabled } /> }
                { this.state.conf === true &&
                    <ResumoAnualVis
                        centroNome={ this.state.centroNome }
                        ano={ this.state.ano }
                        resumoAnual={ this.state.resumoAnual }
                        voltar2={ this.voltar2 } /> }
            </div>
        );
    }

}

export default withRouter(ResumoAnual);

